import React from "react";
import CategoryPage from "./CategoryPage";

const ITEMS = [
  {
    slug: "agenti-ai",
    to: "/servizi/agenti-ai",
    label: "Agenti AI",
    tag: "Servizi",
    desc: "Assistenti intelligenti al servizio del tuo tempo.",
  },
  {
    slug: "consulenze",
    to: "/servizi/consulenze",
    label: "Consulenze",
    tag: "Servizi",
    desc: "Confronto professionale per decisioni concrete.",
  },
  {
    slug: "sessioni",
    to: "/servizi/sessioni",
    label: "Sessioni",
    tag: "Servizi",
    desc: "Incontri dedicati, mirati sull'obiettivo.",
  },
];

export default function ServiziPage() {
  return (
    <CategoryPage
      eyebrow="Servizi"
      title="Presenza dove serve."
      description="Agenti AI, consulenze e sessioni: interventi mirati sul tempo giusto."
      items={ITEMS}
      testId="servizi"
    />
  );
}
